export { default } from './FormDialog.vue'
